import {
  Component,
  Input,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { Router } from '@angular/router';

import { DistrictDTO } from 'src/app/common/dtos/district.dto';
import { PaginationDTO } from 'src/app/common/types/responses/responses-template';
import { UserDTO } from 'src/app/common/state/user/user.dto';
import { UserDtoApiResponse } from 'src/app/common/types/responses/responses';
import { Subject } from 'rxjs';
import {
  SortEvent,
  SortableHeader,
} from '../../directives/sortable-header.directive';

import { UserSearchService } from '../../services/user-search/user-search.service';

@Component({
  selector: 'app-roster-users',
  templateUrl: './roster-users.component.html',
  styleUrls: ['./roster-users.component.scss'],
})
export class RosterUsersComponent implements OnInit {
  @Input() district: DistrictDTO;

  @ViewChildren(SortableHeader) headers: QueryList<SortableHeader>;

  searchTermUpdate = new Subject<string>();

  isLoading = true;

  loadingIcons = true;

  districtCode: string;

  userList: UserDTO[];

  searchTerm = '';

  numPerPage = 20;

  listMeta: PaginationDTO;

  response: UserDtoApiResponse;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  sortIconTemp: any = {
    name: 'gray',
    email: 'gray',
    school: 'gray',
    cohort: 'gray',
  };

  sortBy = '';

  sortByDesc = false;

  column = '';

  direction = '';

  loading = false;

  constructor(
    public router: Router,
    private userSearchService: UserSearchService
  ) {}

  ngOnInit(): void {
    if (this.district) {
      this.userSearchService.itemsFull.subscribe((res) => {
        this.userList = res.items;
        this.userList = this.userList.map((item) => {
          const item2 = item;
          item2.isSelected = false;
          return item2;
        });
        this.listMeta = res._meta;
        this.isLoading = false;
        setTimeout(() => {
          this.updateColumns();
        }, 350);
      });
      this.getUsers();
    }
  }

  getUsers(term = '', currentPage = 1) {
    const districtIds: number[] = [];
    if (this.district) {
      districtIds.push(this.district.id);
    }

    this.userSearchService.searchFull(
      term,
      districtIds,
      '',
      this.numPerPage,
      currentPage,
      this.sortBy,
      this.sortByDesc
    );
  }

  onSort({ column, direction }: SortEvent) {
    this.sortBy = column;
    this.sortByDesc = false;
    if (direction === 'asc') {
      this.sortByDesc = true;
    }

    this.column = column;
    this.direction = direction;

    this.loadingIcons = true;
    this.getUsers();
  }

  showCoachFullName(user: UserDTO) {
    const searchTerm = this.searchTerm;
    this.searchTerm = searchTerm;
    const getUser = user;
    if (
      getUser.coach?.profile?.first_name &&
      getUser.coach?.profile.last_name
    ) {
      return `${getUser.coach?.profile?.first_name} ${getUser.coach?.profile?.last_name}`;
    }
    return '-';
  }

  updateColumns() {
    this.headers.forEach((header) => {
      if (header.sortable !== this.column) {
        header.direction = '';
        this.sortIconTemp[header.sortable] = 'gray';
      } else {
        this.sortIconTemp[header.sortable] = 'none';
      }
    });

    if (this.direction === '' || this.column === '') {
      this.sortIconTemp[this.column] = 'gray';
    }
    this.loadingIcons = false;
  }

  paginationChange() {
    this.getUsers('', this.listMeta.currentPage);
  }
}
